var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcVision = function SvgIcVision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.781.47c9.265.242 13.627 7.677 14.179 8.756.552 1.079-4.655 7.93-12.212 8.74C8.192 18.774.833 12.738 0 9.765 1.66 6.006 7.153.521 13.781.471Z",
    stroke: "#6B6C72",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B6C72",
    cx: 14.275,
    cy: 9.255,
    r: 5.49
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 15.702,
    cy: 10.212,
    r: 1.867
  }))));
};
export default SvgIcVision;